import React from 'react'
import Img from "gatsby-image";

const Hero = ({headerimg}) => (<Img className="hero" fluid={headerimg}/>)

export default Hero
